module.exports = new __parcel__URL__("help_pane_divider.7afe5319.png").toString();